<header class="p-0" aria-labelledby="ticket-detail-title">
  <div
    class="font-lato flex flex-col items-start gap-2 lg:flex-row lg:items-center lg:justify-between lg:gap-x-4"
  >
    <div class="flex min-w-0 items-center gap-3">
      <div class="text-sm leading-none font-bold uppercase">
        {{ ticket().CaseNumber || 'Ticket number unavailable' }}
      </div>
      <span
        class="font-lato rounded-md border px-2 py-1 text-[11px] leading-none font-bold uppercase"
        [ngClass]="statusBadgeClass()"
      >
        {{ statusLabel() }}
      </span>
    </div>

    <div class="font-lato text-xs text-gray-400 lg:text-sm">
      {{ statusDateLabel() }}
    </div>
  </div>

  <h2
    id="ticket-detail-title"
    class="font-montserrat mt-3 mb-3 text-lg leading-snug font-semibold wrap-break-word md:text-xl lg:mb-4"
  >
    {{ title() }}
  </h2>
</header>
